import Decimal from "decimal.js";
import { z } from "zod";

export const ExpirationPositionAdjustmentLegValidation = z.enum([
  "step_one",
  "step_two",
  "step_three",
  "double_up",
]);

export const CreateExpirationPositionAdjustmentValidation = z.object({
  layer_id: z.string().uuid(),
  leg: ExpirationPositionAdjustmentLegValidation,
  position_uom_quantity_override: z
    .string()
    .trim()
    .optional()
    .refine(
      (value: string | undefined): boolean => {
        if (value === undefined || value === "") return true;
        try {
          const quantity = new Decimal(value);
          return quantity.isFinite() && quantity.isPositive();
        } catch {
          return false;
        }
      },
      "Position UOM quantity must be positive",
    )
    .transform((value: string | undefined): string | undefined =>
      value === "" ? undefined : value,
    ),
});

export type ExpirationPositionAdjustmentLeg = z.infer<
  typeof ExpirationPositionAdjustmentLegValidation
>;
export type CreateExpirationPositionAdjustmentInput = z.infer<
  typeof CreateExpirationPositionAdjustmentValidation
>;
